export default "__VITE_ASSET__f025ad04__"